import React from "react";
import { useContext, useEffect, useState } from "react";
import { SignInStatus, TKAccountContext } from "tripkit-react/dist/account/TKAccountContext";
import TKUIUserAccountView from "tripkit-react/dist/account/TKUIUserAccountView";
import { ClientContext } from "../client/ClientProvider";
import RiderCategoriesSetting from "../settings/RiderCategoriesSetting";

const RequireUserInfo: React.FC<{}> = () => {
    const [showAccountForm, setShowAccountForm] = useState(false);
    const { status, userAccount, logout, onUserChange, getUserAccountRef } = useContext(TKAccountContext);
    const { client } = useContext(ClientContext);
    const hasRiderCategories = !!client?.profile?.riderCategories;
    const shouldPromptRiderCategories = hasRiderCategories && !userAccount?.appData?.categories_prompted_at;
    useEffect(() => {
        if (status === SignInStatus.signedIn && userAccount && (!userAccount.name || !userAccount.phone || shouldPromptRiderCategories)) {
            setShowAccountForm(true);
        }
    }, [status, !!userAccount, shouldPromptRiderCategories]);
    async function handleClose() {
        const currentUser = getUserAccountRef() ?? userAccount;
        if (currentUser && (!currentUser.name || !currentUser.phone)) {
            logout();
        }
        if (currentUser && shouldPromptRiderCategories) {
            onUserChange?.({
                ...currentUser,
                appData: {
                    ...(currentUser.appData ?? {}),
                    categories_prompted_at: new Date().toISOString()
                }
            });
        }
        setShowAccountForm(false);
    }
    return showAccountForm ?
        <TKUIUserAccountView
            onRequestClose={handleClose}
            mode="editOnly"
            phoneNote={client?.uiConfig?.messages?.smsDisclaimer?.text}
            renderMoreAccountSettings={({ user, onUserChange, readonly }) => <RiderCategoriesSetting user={user} onUserChange={onUserChange} readonly={readonly} />}
        /> : null;
}

export default RequireUserInfo;
